/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { getPendingTokenRefresh } from '@/apiClient';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB',
      );
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updated() {
      console.log('New content is available; please refresh.');
      // skipWaiting is set in workbox config, so the new SW is already
      // active — reload to pick up the new chunks immediately. But if a
      // token refresh is in flight, reloading right now would tear the page
      // down before the rotated refresh_token gets persisted to
      // localStorage, even though the backend already consumed the old one
      // — the next load would then retry with a stale token and get
      // rejected as reused/invalid. Wait for it (bounded, in case it never
      // settles) before reloading.
      const pendingRefresh = getPendingTokenRefresh();
      if (pendingRefresh) {
        void Promise.race([
          pendingRefresh.catch(() => undefined),
          new Promise((resolve) => setTimeout(resolve, 10000)),
        ]).then(() => window.location.reload());
      } else {
        window.location.reload();
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
